module.exports = __webpack_public_path__ + "static/media/w-logo.43e944c9.png";